import { createFeatureSelector, createReducer, createSelector, on } from '@ngrx/store';
import { AUTH_FEATURE_KEY, AuthState } from './auth.reducer';

export const selectAuthState = createFeatureSelector<AuthState>(AUTH_FEATURE_KEY);

export const selectAuthUser = createSelector(selectAuthState, (state) => state.user)
export const selectAuthError = createSelector(selectAuthState, (state) => state.error)
export const selectAuthIsAuth = createSelector(selectAuthState, (state) => state.isAuth)